<template>
  <section v-if="displayPaymentSection()">
    <div class="card panel-white">
      <div class="card-body">
        <h3>{{ title }}</h3>
        <p>{{ message }}</p>
        <div class="row no-gutters">
          <div class="col-12">
            <button class="btn btn-info btn-block" @click="openPaymentDialog()" v-if="$route.matched[0].path === '/chat-booking'">
              {{ $t('message.service_request.service_request_button_payment') }}
            </button>
            <router-link class="btn btn-info btn-block"
                         :to="`/service-requests/${serviceRequest.id}/payment`"
                         v-else>
              {{ $t('message.service_request.service_request_button_payment') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      serviceRequest: Object
    },
    data () {
      return {
        title: this.$i18n.t('message.service_request.service_request_payment_title01'),
        message: this.$i18n.t('message.service_request.service_request_payment_remark01')
      }
    },
    methods: {
      openPaymentDialog () {
        this.$emit('openPaymentDialog', true)
      },
      displayPaymentSection () {
        let result = false
        if (this.serviceRequest && this.serviceRequest.is_confirmed === 1) {
          const serviceRequestPayments = this.serviceRequest.service_request_payments
          if (serviceRequestPayments) {
            const numPayment = serviceRequestPayments.length
            const paymentStatus = this.serviceRequest.payment_status
            if (this.serviceRequest.promotion_cost) {
              if ((paymentStatus === 0 && numPayment === 0) || (paymentStatus === 3 && numPayment === 1)) {
                if (paymentStatus === 0 && numPayment === 0) {
                  this.title = this.$i18n.t('message.service_request.service_request_payment_title03')
                  this.message = this.$i18n.t('message.service_request.service_request_payment_remark03')
                } else if (paymentStatus === 3 && numPayment === 1) {
                  this.title = this.$i18n.t('message.service_request.service_request_payment_title01')
                  this.message = this.$i18n.t('message.service_request.service_request_payment_remark01')
                }
                result = true
              } else if (paymentStatus === 1 && numPayment === 2 && this.serviceRequest.service_request_status_id === 12) {
                this.title = this.$i18n.t('message.service_request.service_request_payment_title02')
                this.message = this.$i18n.t('message.service_request.service_request_payment_remark02')
                result = true
              }
            } else {
              if (paymentStatus === 0 && numPayment === 0) {
                result = true
              } else if (paymentStatus === 1 && numPayment === 1 && this.serviceRequest.service_request_status_id === 12) {
                this.title = this.$i18n.t('message.service_request.service_request_payment_title02')
                this.message = this.$i18n.t('message.service_request.service_request_payment_remark02')
                result = true
              }
            }
          }
        }
        return result
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/serviceRequest/Components/PaymentSection.vue